export default __webpack_public_path__ + "static/media/naruto.3116eecc.png";